export const DEFAULT_QUESTION_KEYS = [
  'musicIq.defaultQuestions.brunoMars',
  'musicIq.defaultQuestions.duaLipa',
  'musicIq.defaultQuestions.edSheeran',
  'musicIq.defaultQuestions.lizzo',
  'musicIq.defaultQuestions.bensonBoone',
];
